<template>
  <v-container>
    <div :style="{ width: props.readOnly ? '300px' : '500px' }" :id="mathFieldID"></div>
  </v-container>
</template>

<script lang="ts" setup>
import { uuid4 } from "@sentry/core";
import { MathfieldElement } from "mathlive";
import { onMounted, ref } from "vue";

const modelValue = defineModel<string>();

const props = defineProps({
  readOnly: {
    type: Boolean,
    default: false,
  },
});

const mathFieldID = uuid4();

onMounted(() => {
  const mathFieldElement = document.getElementById(mathFieldID) as HTMLElement;
  const mfe = new MathfieldElement();
  mfe.readOnly = props.readOnly;
  mfe.oninput = (e) => {
    modelValue.value = mfe.value;
  };
  mfe.style.width = "100%";
  console.log("asdfasfd", modelValue.value);
  mfe.value = modelValue.value;
  mathFieldElement.appendChild(mfe);


});
</script>
